export default {
  path: "/HighlightedTopic/Location",
  name: "Highlighted Topic - Crash Location",
  type: "highlightedTopic",
  htmlContent: "HT-Location.html",
  keyPoints: [
    "Providing an accurate crash location provides safety professionals with the ability to monitor and track crash trends across the state. ",
    "Utilize well known street names versus less common names to provide the best location Identification.",
    "DO NOT use business names or local landmarks (e.g., McDonald’s entrance, old red barn, high school) in the <u>At its Intersection With</u> or <u>Not at its Intersection But</u> data fields.",
    "Your location information, <u>Diagram</u>, and <u>Narrative</u> should all match regarding road names, directions, and distances. ",
  ],
  keywords: ["location", "GIS", "road", "county", "city", "intersection", "direction"],
  alert: {
    title: "This is a CRITICAL Data Item.",
    body: "This is a mandatory field on the crash report. All reports must have this field coded.  Additionally, this data item is critical to the highway safety community.  Incorrect reporting can negatively impact programming decisions and investments.",
  },
  scenarios: [
    {
      name: "Scenario 1 – Intersection Crash (Case 1)",
      description: `
        <p>General description: Unit 1 is traveling East on NE Ponce De Leon Ave. Unit 2 is traveling West on NE Ponce De Leon Ave, made a left turn onto North Highland Ave</p>
        <img class="accordion-image" src='https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/Location/LocationScenario1.png'/>
<p><u>County</u> = Fulton</p>
<p><u>City</u> = Atlanta</p>
<p><u>Road of Occurrence</u> = NE PONCE DELEON AVENUE</p>
<p><u>At its Intersection With</u> = NORTH HIGHLAND AVENUE </p>
<p><u>Not at Its Intersection But</u> = Blank; Do not check Unit of Measure or Direction</p>
<p><u>Of</u> = Blank</p>
<p><u>Latitude</u> = 33.77383</p>
<p><u>Longitude</u> = -84.35252</p>
<p><u>Location</u> at Area of Impact = (7) On Roadway – Roadway Intersection</p>
<p><u>Narrative</u> (location part only) = <br>
 At (restate time) I arrived on scene at an angle crash that occurred at the intersection of Ponce Deleon Ave and North Highland Ave. My investigation revealed that V1 was traveling east bound on Ponce DeLeon Ave approaching N. Highland Ave. V2 was traveling west bound on Ponce DeLeon Ave approaching N. Highland Ave. V2 attempted to turn left onto south bound N. Highland Ave. 
</p>


        `,
    },
    {
      name: "Scenario 2 – Linear Crash (Case 2)",
      description: `
        <p>General Description: Unit 1 was traveling West on I -20 approaching the overpass of Boulevard SE. Unit 1 spun out of control.  </p>

<img class="accordion-image" src='https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/Location/LocationScenario2.png'/>
<p><u>County</u> = Fulton</p>
<p><u>City</u> = Atlanta</p>
<p><u>Road of Occurrence</u> = I-20 WB </p>
<p><u>At its Intersection With</u> = Blank</p>
<p><u>Not at Its Intersection But</u> = 25 Feet East</p>
<p><u>Of</u> = Boulevard SE Overpass</p>
<p><u>Latitude</u> = 33.74353</p>
<p><u>Longitude</u> = -84.367485</p>
<p><u>Location at Area of Impact</u> = (4) Median</p>

<p><u>Narrative</u> (location part only) =</p>
<p><u>At (restate time) I arrived on scene at a single vehicle crash on</u> I –20 west bound approaching the overpass of Boulevard SE. <u>My investigation revealed that V1 was traveling west bound</u> when D1 lost control and exited the lane to the left and struck the center concrete barrier (MHE) twenty-five feet east of the Boulevard St overpass; then traveled seventy-five feet west bound and struck the barrier a second time then traveled west by northwest 125 feet and struck the guardrail on the right shoulder of I-20 West. </p>`,
    },
  ],
};
